export const checkPhoneNumberFormat = (phone, phone_regex) => {
    let regex = phone_regex;
    return phone.match(regex) ? true : false;
}